jQuery(function($) {
  $('.testimonial__item .testimonial__item--img').on('mouseenter touchstart', function() {
    testimonialNumber = $(this).attr('data-testimonial');

    $('.testimonial__item--img').removeClass('active');
    $(this).addClass('active');

    $('.testimonial__item--content').each(function(idx, item) {
      if($(item).attr('data-testimonial') == testimonialNumber) {
        $(item).addClass('active');
      }
      else {
        $(item).removeClass('active');
      }
    });
  });

  $('.testimonial__item--content button').click(function() {
    $('.testimonial__overlay').addClass('active');

  });

  $('.testimonial__overlay--close').click(function() {
    $('.testimonial__overlay iframe').each(function(){
      $(this).attr('src', $(this).attr('src'));
    })
    $('.testimonial__overlay').removeClass('active');
  })

  // Homepage Testimonial horizontal scroller
  if (window.innerWidth <= 1024) {
    $('.testimonial__item').flickity({
      pageDots: false,
      prevNextButtons: false
    });
  }

  $(window).on('load resize', function() {
    if ($('.testimonial__overlay.active').length === 0) {
      $('.testimonial__item--img').removeClass('active');
      $('.testimonial__item--content').removeClass('active');
      if (window.innerWidth < 1024) {
        $('.mobile-default').addClass('active');
      } else {
        $('.desktop-default').addClass('active');
      }
    }
    
  });

});

